import { useCallback, useState } from 'react'

import { Descriptions, InlineTextButton, Space } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { type ConversationDetailKeyValueBlock } from '../../value-objects/ConversationTurnItem'
import { ConversationMarkdown } from '../ConversationMarkdown'
import messages from './messages'
import { CatalogItemDetailsDescriptionsStyled } from './styles/CatalogItemDetailsDescriptionsStyled'

export interface ICatalogItemDetailsKeyValueBlockProps {
  block: ConversationDetailKeyValueBlock
}

export const CatalogItemDetailsKeyValueBlock = ({
  block,
}: ICatalogItemDetailsKeyValueBlockProps) => {
  const intl = useProcurifyIntl()
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpanded = useCallback(
    () => setIsExpanded((expanded) => !expanded),
    []
  )

  const isCollapsible =
    block.collapsedAfter !== undefined &&
    block.rows.length > block.collapsedAfter
  const visibleRows =
    isCollapsible && !isExpanded
      ? block.rows.slice(0, block.collapsedAfter)
      : block.rows

  return (
    <Space direction='vertical' size='small'>
      <CatalogItemDetailsDescriptionsStyled>
        <Descriptions valueWidth='fill'>
          {visibleRows.map((row) => (
            <Descriptions.Item
              key={`${row.label}-${row.value}`}
              label={<span className='fs-mask'>{row.label}</span>}
            >
              {row.value ? (
                <span className='fs-mask'>
                  <ConversationMarkdown content={row.value} isInline />
                </span>
              ) : null}
            </Descriptions.Item>
          ))}
        </Descriptions>
      </CatalogItemDetailsDescriptionsStyled>
      {isCollapsible && (
        <InlineTextButton
          type='button'
          data-analytics-id='catalog-item-details-section-see-more'
          onClick={toggleExpanded}
        >
          {intl.formatMessage(isExpanded ? messages.seeLess : messages.seeMore)}
        </InlineTextButton>
      )}
    </Space>
  )
}
